var _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigureCategory1Y(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6815 20.3841C12.6815 21.3242 11.9194 22.0864 10.9793 22.0864C10.0392 22.0864 9.27707 21.3242 9.27707 20.3841V20.3628C9.27707 19.7103 8.87606 19.1263 8.2687 18.8878C7.56432 18.6112 6.91296 18.2292 6.33394 17.7611C5.82472 17.3495 5.11787 17.2855 4.54847 17.6089L4.54604 17.6103C3.72599 18.0723 2.68524 17.7847 2.22138 16.9678C1.75752 16.1509 2.04631 15.1142 2.86636 14.6521L2.87947 14.6446C3.44006 14.3263 3.75659 13.6992 3.66722 13.0607C3.6202 12.7248 3.59585 12.3815 3.59585 12.0326C3.59585 11.6683 3.62245 11.3103 3.67365 10.9602C3.76808 10.3148 3.44721 9.67908 2.88002 9.35694L2.86632 9.34915C2.04627 8.88708 1.75752 7.85029 2.22138 7.03343C2.68524 6.21652 3.72603 5.92889 4.54608 6.39096L4.5949 6.41871C5.16195 6.74077 5.86468 6.67753 6.37471 6.27116C6.9427 5.81863 7.57913 5.44835 8.26598 5.17837C8.87427 4.93925 9.27707 4.35585 9.27707 3.70224C9.27707 2.76213 10.0392 2 10.9793 2C11.9194 2 12.6815 2.76213 12.6815 3.70224V3.71934C12.6815 4.36994 13.0807 4.95138 13.685 5.1925C14.3642 5.4635 14.9934 5.83267 15.5553 6.28253C16.0655 6.69098 16.7696 6.75613 17.3379 6.43339L17.4125 6.391C18.2326 5.92897 19.2734 6.21657 19.7372 7.03347C20.201 7.85033 19.9123 8.88712 19.0922 9.34919L19.0314 9.38375C18.4696 9.70279 18.1515 10.3321 18.244 10.9715C18.2941 11.3179 18.3202 11.6722 18.3202 12.0325C18.3202 12.3745 18.2968 12.6923 18.2516 13.0219M18.8521 16.1286H22.0864M15.4477 19.1075H18.6819M22.0864 22.0864H18.8521M10.9793 15.2349C12.742 15.2349 14.171 13.8059 14.171 12.0432C14.171 10.2805 12.742 8.8515 10.9793 8.8515C9.21659 8.8515 7.78761 10.2805 7.78761 12.0432C7.78761 13.8059 9.21659 15.2349 10.9793 15.2349Z",
    stroke: "#FFC400",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0855,
    cy: 19.108,
    r: 0.851118,
    fill: "#FFC400"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4468,
    cy: 22.0865,
    r: 0.851118,
    fill: "#FFC400"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4468,
    cy: 16.1285,
    r: 0.851118,
    fill: "#FFC400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigureCategory1Y);
export default __webpack_public_path__ + "static/media/ConfigureCategory1y.a2cd8b1d2db30024d2e7cbbe6e83fc2f.svg";
export { ForwardRef as ReactComponent };